import React, { useState, useEffect } from 'react';
import { Form, message } from 'antd';
import { useNavigate } from "react-router-dom";
import Header from '../../components/Shared/Header';
import Loading from "../../components/Shared/Loading";
import { createClient, getRoles } from '../../Utils/client/client';
import CustomerForm from '../../components/Client/CustomerForm';

const CreateCustomer = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const res = await getRoles();
      // Filter to show only admin and client roles
      const filteredRoles = res.data.filter(role => 
        role.name === 'superadmin' || role.name === 'client'
      );
      setRoles(filteredRoles);
    } catch (error) {
      console.error('Error fetching roles:', error);
      message.error('Erreur lors du chargement des rôles');
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    const formData = {
      ...values,
      company_logo: values.company_logo ? values.company_logo[0].thumbUrl?.split(',')[1] : null,
      first_name: values.full_name?.split(' ')[0],
      last_name: values.full_name?.split(' ').slice(1).join(' ')
    };
    try {
      await createClient(formData);
      setLoading(false);
      message.success('Client créé avec succès!');
      navigate('/admin/client/all');
    } catch (error) {
      if (error.status === 409) {
        message.error('Un compte avec cet email existe déjà');
      }else{
        console.error(error);
        message.error('Erreur lors de la création du client');
      }
      setLoading(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <div className="bg-gray-100 min-h-screen">
      <Header title="Création client" />
      <div className="p-8">
        <CustomerForm 
          form={form} 
          onFinish={onFinish} 
          isEditing={false}
          roles={roles}
        />
      </div>
    </div>
  );
};

export default CreateCustomer;